import { DECLARED_COOKIES, decodeContactEmail } from '@trenigo/brand';
import { LandingBrandLogo } from '../components/LandingBrandLogo.js';
import { useIsHydrated } from '../lib/use-is-hydrated.js';
import './LandingPage.css';
import './CookiesPage.css';

/**
 * Kontaktní e-mail z @trenigo/brand. Adresa se skládá až v prohlížeči po hydrataci, takže
 * v předrenderovaném HTML (a pro roboty bez JavaScriptu) zůstává obfuskovaná stejně jako dřív
 * v SPA aplikace. Do té doby je na jejím místě neutrální text.
 */
function ObfuscatedContactEmail() {
  const hydrated = useIsHydrated();
  if (!hydrated) {
    return <span className="cookies-contact-pending">kontaktní e-mail správce</span>;
  }
  const email = decodeContactEmail();
  return <a href={`mailto:${email}`}>{email}</a>;
}

/**
 * Stránka o cookies a zpracování osobních údajů na samostatném webu (FR01
 * 20261001_LandingPage/002_Marketing, FR-07). Obsah (seznam cookies a kontakt) jsou data
 * z @trenigo/brand shodná se stránkou /cookies v aplikaci, styl je landing page (bez Tailwindu
 * a aplikačních tokenů).
 */
export function CookiesPage() {
  return (
    <div className="landing">
      <main className="container cookies-page" id="obsah">
        <a className="cookies-brand" href="/" aria-label="Trenigo – úvodní stránka">
          <LandingBrandLogo alt="Trenigo SportAkademie" className="brand-logo" />
        </a>
        <article className="cookies-card">
          <h1>Cookies a ochrana osobních údajů</h1>
          <p>
            Aplikace Trenigo používá výhradně cookies nezbytné pro její chod - žádné analytické ani marketingové
            cookies ani jiné sledovací nástroje. Pro tyto nezbytné cookies proto podle platné legislativy stačí
            informační povinnost, ne aktivní souhlas.
          </p>

          <h2>Přehled cookies</h2>
          <div className="cookies-table-wrap">
            <table className="cookies-table">
              <thead>
                <tr>
                  <th scope="col">Název</th>
                  <th scope="col">Účel</th>
                  <th scope="col">Doba platnosti</th>
                  <th scope="col">Nezbytnost</th>
                </tr>
              </thead>
              <tbody>
                {DECLARED_COOKIES.map((cookie) => (
                  <tr key={cookie.name}>
                    <td className="cookies-name">{cookie.name}</td>
                    <td>{cookie.purpose}</td>
                    <td>{cookie.duration}</td>
                    <td>
                      <strong>Nezbytná</strong> - nevyžaduje souhlas
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2>Zpracování osobních údajů</h2>
          <p>
            Správcem osobních údajů zpracovávaných v souvislosti s provozem aplikace Trenigo je TrenigoCZ spol. s r.o..
          </p>
          <p>
            S dotazy nebo žádostmi týkajícími se zpracování osobních údajů (např. přístup k údajům, jejich oprava
            nebo výmaz) se obraťte na <ObfuscatedContactEmail />.
          </p>

          <a className="cookies-back" href="/">
            <span aria-hidden="true">←</span> Zpět na úvod
          </a>
        </article>
      </main>
    </div>
  );
}
